/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ChartType } from '@models/chart.model';
import { Anchor } from 'chartjs-plugin-datalabels/types/options';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-datalabels-anchor',
  templateUrl: './theme-option-datalabels-anchor.component.html',
  styleUrls: ['./theme-option-datalabels-anchor.component.css']
})
export class ThemeOptionDatalabelsAnchorComponent {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() datalabelsIndex: number;

  color = ItemColor('themes');
  anchors = ['end', 'center', 'start'] as any[];
  icons = ['arrow-alt-from-bottom', 'dot-circle', 'arrow-alt-to-bottom'] as string[];
  optionType: ThemeOptionType = 'datalabels_anchor';
  showDetails: boolean;

  constructor() {}

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

  receiveValue(value: Anchor, type?: ChartType) {
    this.themeOptions.setDatalabels(this.optionType, value, this.datalabelsIndex, type ? [type] : undefined);
  }

}
